import axios from 'axios';
import { URL_MADE } from './config';

export async function getPMadeList() {
    const result = await axios.get(URL_MADE);
    return result.data.data;
};


